import { get, post } from '../../apiClient';
import { API_ENDPOINTS } from '../../config';

const linkedInService = {
  /**
   * Get LinkedIn OAuth authorization URL
   */
  getAuthorizationUrl: async () => {
    try {
      const response = await get(API_ENDPOINTS.CRM.LINKEDIN.AUTHORIZE);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          authorizationUrl: response.data.authorizationUrl,
          state: response.data.state
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to get authorization URL'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to get authorization URL'
      };
    }
  },

  /**
   * Sync LinkedIn leads
   * Uses stored access token (does NOT require accessToken parameter)
   */
  syncLeads: async (lastSyncTime = null) => {
    try {
      const response = await post(API_ENDPOINTS.CRM.LINKEDIN.SYNC, {
        lastSyncTime
      });

      if (response && response.responseCode === 200) {
        return {
          success: true,
          ...response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to sync LinkedIn leads'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to sync LinkedIn leads'
      };
    }
  },

  /**
   * Get Lead Gen Forms
   * Uses stored access token (does NOT require accessToken parameter)
   */
  getForms: async () => {
    try {
      const response = await get(API_ENDPOINTS.CRM.LINKEDIN.FORMS);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          forms: response.data.forms,
          count: response.data.count
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to fetch Lead Gen Forms'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to fetch Lead Gen Forms'
      };
    }
  },

  /**
   * Get LinkedIn integration status
   */
  getIntegrationStatus: async () => {
    try {
      const response = await get(API_ENDPOINTS.CRM.LINKEDIN.STATUS);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          ...response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to get integration status'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to get integration status'
      };
    }
  },

  /**
   * Disconnect LinkedIn integration
   */
  disconnect: async () => {
    try {
      const response = await post(API_ENDPOINTS.CRM.LINKEDIN.DISCONNECT);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          message: response.responseMessage || 'LinkedIn disconnected successfully'
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to disconnect LinkedIn'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to disconnect LinkedIn'
      };
    }
  }
};

export default linkedInService;

